import { FieldValues } from "react-hook-form";

import { CentrelinkCardinput, VerifyIdentityInput } from "@api/graphql";

export const prepareVerifyIdentityInput = (data: FieldValues, participant_id: number): VerifyIdentityInput => {
  switch (data.method) {
    case "Australian Passport": {
      return {
        date_of_birth: data.date_of_birth,
        participant_id,
        aus_passport: {
          number: data.number,
        },
      };
    }
    case "Medicare Card":
      return {
        date_of_birth: data.date_of_birth,
        participant_id,
        medicare: {
          cardnumber: data.cardnumber,
          nameline1: data.nameline1,
          cardtype: data.cardtype,
          expiry: data.expiry,
          individualnumber: data.individualnumber,
        },
      };
    case "Centrelink Card":
      return {
        date_of_birth: data.date_of_birth,
        participant_id,
        centrelink: {
          customerreferencenumber: data.customerreferencenumber,
          name: data.name,
          cardexpirydate: data.cardexpirydate,
          cardtype:
            data.cardtype === "SHC"
              ? CentrelinkCardinput.COMMONWEALTH_SENIORS_HEALTH_CARD
              : data.cardtype === "HCC"
                ? CentrelinkCardinput.HEALTH_CARE_CARD
                : CentrelinkCardinput.PENSIONER_CONCESSION_CARD,
        },
      };
    case "New Zealand Passport":
      return {
        date_of_birth: data.date_of_birth,
        participant_id,
        nz_passport: {
          number: data.number,
          expiry: data.expiry,
        },
      };
    case "New Zealand Drivers Licence":
      return {
        date_of_birth: data.date_of_birth,
        participant_id,
        nz_drivers_license: {
          number: data.number,
          version: data.version,
        },
      };
    default:
      return {
        date_of_birth: data.date_of_birth,
        participant_id,
        aus_drivers_license: {
          state: data.state,
          number: data.number,
          cardNumber: data.cardNumber,
        },
      };
  }
};
